import { render, staticRenderFns } from "./CancelBooking.vue?vue&type=template&id=27f5dffb&scoped=true&"
import script from "./CancelBooking.vue?vue&type=script&lang=js&"
export * from "./CancelBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f5dffb",
  null
  
)

export default component.exports